// Fill the hidden Day Program Selections field(s) with the extras the visitor
// selected in the day-program block (stored in sessionStorage). Filled on load
// and refreshed on submit so late changes in another tab are picked up too.
document.addEventListener('DOMContentLoaded', function () {
	var inputs = document.querySelectorAll('.day-program-selections__input');

	if (!inputs.length) {
		return;
	}

	function fillInputs() {
		var data = '';

		try {
			data = sessionStorage.getItem('dayprogram_selections') || '';
		} catch (e) {
			// Storage unavailable: leave the field empty.
		}

		// Arriving from a tour page (?reis={slug}): only pass that tour's
		// selections along, so entries and notifications stay accurate.
		var reis = new URLSearchParams(window.location.search).get('reis');

		if (data && reis) {
			try {
				var parsed = JSON.parse(data);
				var filtered = {};

				Object.keys(parsed).forEach(function (id) {
					if (parsed[id] && parsed[id].slug === reis) {
						filtered[id] = parsed[id];
					}
				});

				data = Object.keys(filtered).length ? JSON.stringify(filtered) : '';
			} catch (e) {
				// Corrupt storage: leave the field empty.
				data = '';
			}
		}

		inputs.forEach(function (input) {
			input.value = data;
		});
	}

	fillInputs();

	inputs.forEach(function (input) {
		var form = input.closest('form');

		if (form) {
			form.addEventListener('submit', fillInputs);
		}
	});
});

// Fill the hidden Affiliate field(s) with the affiliate stored in
// localStorage by the theme's affiliate capture script. Filled on load and
// refreshed on submit; expired values are cleared and yield an empty field.
document.addEventListener('DOMContentLoaded', function () {
	var inputs = document.querySelectorAll('.gf-affiliate__input');

	if (!inputs.length) {
		return;
	}

	function getAffiliate() {
		try {
			var raw = localStorage.getItem('affiliate');

			if (!raw) {
				return '';
			}

			var data = JSON.parse(raw);

			if (!data || typeof data.value !== 'string') {
				return '';
			}

			if (data.expires && Date.now() > data.expires) {
				localStorage.removeItem('affiliate');
				return '';
			}

			return data.value;
		} catch (e) {
			// Storage unavailable or corrupt: leave the field empty.
			return '';
		}
	}

	function fillInputs() {
		var value = getAffiliate();

		inputs.forEach(function (input) {
			input.value = value;
		});
	}

	fillInputs();

	inputs.forEach(function (input) {
		var form = input.closest('form');

		if (form) {
			form.addEventListener('submit', fillInputs);
		}
	});
});

document.addEventListener('click', function (e) {
	var btn = e.target.closest('.traveler-counter__btn');
	if (!btn) {
		return;
	}

	var row = btn.closest('.traveler-counter__controls');
	var valueEl = row.querySelector('.traveler-counter__value');
	var current = parseInt(valueEl.textContent, 10) || 0;
	var action = btn.dataset.action;

	if (action === 'plus') {
		var max = parseInt(btn.dataset.max, 10) || 20;
		if (current < max) {
			valueEl.textContent = current + 1;
		}
	} else if (action === 'minus') {
		var min = parseInt(btn.dataset.min, 10) || 0;
		if (current > min) {
			valueEl.textContent = current - 1;
		}
	}

	var counter = btn.closest('.traveler-counter');
	var hidden = counter.querySelector('.traveler-counter__hidden');
	var values = [];
	counter.querySelectorAll('.traveler-counter__value').forEach(function (el) {
		var category = el.dataset.category;
		var value = parseInt(el.textContent, 10) || 0;
		values.push(category + ':' + value);
	});
	hidden.value = values.join('|');
});

// Medereizigers repeater: add and remove traveler blocks.
document.addEventListener('click', function (e) {
	var addBtn = e.target.closest('.medereizigers__add');
	var removeBtn = e.target.closest('.medereizigers__remove');

	if (!addBtn && !removeBtn) {
		return;
	}

	var wrapper = (addBtn || removeBtn).closest('.medereizigers');
	var list = wrapper.querySelector('.medereizigers__list');
	var max = parseInt(wrapper.dataset.max, 10) || 9;

	if (addBtn) {
		if (list.querySelectorAll('.medereizigers__item').length >= max) {
			return;
		}

		// Use the highest existing index + 1 so input names never collide
		// after blocks in the middle have been removed.
		var nextIndex = 0;
		list.querySelectorAll('.medereizigers__item').forEach(function (item) {
			var index = parseInt(item.dataset.index, 10);
			if (!isNaN(index) && index >= nextIndex) {
				nextIndex = index + 1;
			}
		});

		var template = wrapper.querySelector('.medereizigers__template');
		var holder = document.createElement('div');
		holder.innerHTML = template.innerHTML.replace(/__INDEX__/g, nextIndex);
		list.appendChild(holder.firstElementChild);
	}

	if (removeBtn) {
		removeBtn.closest('.medereizigers__item').remove();
	}

	// Renumber the visible traveler numbers and toggle the add button.
	var items = list.querySelectorAll('.medereizigers__item');
	items.forEach(function (item, i) {
		var number = item.querySelector('.medereizigers__number');
		if (number) {
			number.textContent = i + 1;
		}
	});
	wrapper.querySelector('.medereizigers__add').hidden = items.length >= max;
});
